import { render, staticRenderFns } from "./Gaojing.vue?vue&type=template&id=5a0331fe&scoped=true&"
import script from "./Gaojing.vue?vue&type=script&lang=js&"
export * from "./Gaojing.vue?vue&type=script&lang=js&"
import style0 from "./Gaojing.vue?vue&type=style&index=0&id=5a0331fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0331fe",
  null
  
)

export default component.exports